import {useEffect} from 'react'
import {shallowEqual, useSelector} from 'react-redux'
import actions from 'redux-auto'
import {hasSubmittedChapter} from 'ag-common/tools/ausbildungsplan/recursiveFindSubmittedChapter'
import {usePermissions} from '#hooks/usePermissions'

const chapterStatusSelector = state => state.ausbildungsplan.chapterStatuses

const getConfirmedChapters = chapterStatuses => azubiId => {
  const chapterStatusesForAzubi = chapterStatuses[azubiId]
  if (chapterStatusesForAzubi) {
    return Object.values(chapterStatusesForAzubi).filter(chapter => chapter.status === 'confirmed')
  }
  return []
}

const getSubmittedOrConfirmedChapters = chapterStatuses => azubiId => {
  const chapterStatusesForAzubi = chapterStatuses[azubiId]
  if (chapterStatusesForAzubi) {
    return Object.values(chapterStatusesForAzubi).filter(
      chapter => chapter.status === 'submitted' || chapter.status === 'confirmed',
    )
  }
  return []
}
const getSubmittedChapters = chapterStatuses => azubiId => {
  const chapterStatusesForAzubi = chapterStatuses[azubiId]
  if (chapterStatusesForAzubi) {
    return Object.values(chapterStatusesForAzubi).filter(chapter => chapter.status === 'submitted')
  }
  return []
}
const hasSubmittedChapters = chapterStatuses => azubiId => {
  const chapterStatusesForAzubi = chapterStatuses[azubiId]
  if (chapterStatusesForAzubi) {
    return Object.values(chapterStatuses[azubiId]).some(chapter => chapter.status === 'submitted')
  }
  return false
}
const isChapterSubmitted = chapterStatuses => (azubiId, chapterId) =>
  hasSubmittedChapter(chapterStatuses[azubiId], chapterId)

export function useChapterStatuses() {
  const permissions = usePermissions()
  const chapterStatuses = useSelector(chapterStatusSelector, shallowEqual) || {}
  useEffect(() => {
    if (permissions.ausbildungsplan.viewAusbildungsplanFromOthers) {
      actions.ausbildungsplan.getAllChaptersStatusFromMyAzubis()
    } else if (permissions.ausbildungsplan.edit) {
      actions.ausbildungsplan.getAllChaptersStatus()
    }
  }, [permissions.ausbildungsplan.viewAusbildungsplanFromOthers])
  return {
    chapterStatuses,
    getSubmittedOrConfirmedChapters: getSubmittedOrConfirmedChapters(chapterStatuses),
    hasSubmittedChapters: hasSubmittedChapters(chapterStatuses),
    isChapterSubmitted: isChapterSubmitted(chapterStatuses),
    getConfirmedChapters: getConfirmedChapters(chapterStatuses),
    getSubmittedChapters: getSubmittedChapters(chapterStatuses),
  }
}
